module.exports = __webpack_public_path__ + "img/syllabus-boy-sm.34cf9f9d.png";